import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { CustomLink } from '../../../../common/CustomLink'
import { Panel } from '../../../../common/panel'
import { Table } from '../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../routers/constants'

import { Icon } from '../../../../common/html/icon'
import {
  changePeerOrganizationIds,
  selectPeerOrganizationIds,
} from '../../store/slice'
import {
  changeSelectedCompanyList,
  selectSelectedCompanyList,
} from '../search/popupRecommendationList/store/slice'
import { schema } from './constants'
import { HeaderTable } from './HeaderTable'
import {
  removeOwnershipAndGroup,
  selectIds,
  selectIsLoading,
  selectOwnershipAndGroupItem,
} from './store/slice'
import { getOwnershipAndGroup } from './store/thunk'

export const OwnershipAndGroup = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const locale = useSelector((state) => state.i18n.locale)

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const isLoading = useSelector(selectIsLoading)
  const ids = useSelector(selectIds)
  const peerOrganizationIds = useSelector(selectPeerOrganizationIds)
  const selectedCompanyList = useSelector(selectSelectedCompanyList)

  useEffect(() => {
    dispatch(
      getOwnershipAndGroup({
        organizationId,
        peerOrganizationIds,
      }),
    )
  }, [locale, peerOrganizationIds])

  const onRemoveCompany = (rowId) => () => {
    const filteredCompany = selectedCompanyList.filter(
      (company) => company.id !== rowId,
    )
    const filteredCompanyListIds = filteredCompany.map((item) => item.id)
    dispatch(removeOwnershipAndGroup(rowId))
    dispatch(changeSelectedCompanyList(filteredCompany))
    dispatch(changePeerOrganizationIds(filteredCompanyListIds))
  }

  return (
    <Panel label="companyAnalysis.peerAnalysis.OWNERSHIP_AND_GROUP" isI18n>
      <Table
        ids={ids}
        getDataFromRedux={selectOwnershipAndGroupItem}
        isNoDataWithHead={true}
        isLoading={isLoading}
        renderTHead={() => <HeaderTable headerTable={schema} />}
        autoHeightMax={400}
        schema={schema
          .map((item, index) => {
            if (index === 0) {
              return {
                ...item,
                render: (_val, { rowIndex }) => rowIndex + 1,
              }
            }

            if (index === 1) {
              return {
                ...item,
                render: (val, { rowId }) => (
                  <div className="dFlex alignItemsCenter justifyContentBetween">
                    <CustomLink
                      target="_blank"
                      to={`${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${rowId}`}
                    >
                      <TextEllipsisStaticLine
                        text={val}
                        isI18n={false}
                        lineClamp={2}
                        appendStyle={{ color: '#2C73E8', cursor: 'pointer' }}
                      />
                    </CustomLink>
                    {rowId?.toString() !== organizationId && (
                      <Icon
                        className="icon-delete"
                        onClick={onRemoveCompany(rowId)}
                        style={{
                          color: '#9C9C9C',
                          cursor: 'pointer',
                          paddingLeft: 8,
                        }}
                      />
                    )}
                  </div>
                ),
              }
            }

            if (item.childCol) {
              return item.childCol.map((childItem) => {
                return {
                  ...childItem,
                  render: (val) => val,
                }
              })
            }

            return item
          })
          .flat()}
      />
    </Panel>
  )
}
